import {Component} from '@angular/core';
import {IconComponent} from '@adnova/jf-ng-components';

@Component({
  selector: 'zlng-beleglos-locked',
  templateUrl: './beleglos-locked.component.html',
  styleUrls: ['./beleglos-locked.component.scss'],
  standalone: true,
  imports: [IconComponent],
})
export class BeleglosLockedComponent {
  constructor() {}
}
